import React, { useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
    FaCalendarAlt,
    FaClock,
    FaMapMarkerAlt,
    FaArrowLeft,
    FaUser,
    FaTag,
    FaFileAlt
} from 'react-icons/fa';
import { fetchAgendaTerkini } from '../redux/actions/dataActions';

const AgendaDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const agendaList = useSelector(state => state.data.agendaTerkini);
    const loading = useSelector(state => state.data.loading);

    useEffect(() => {
        if (agendaList.length === 0) {
            dispatch(fetchAgendaTerkini());
        }
    }, [dispatch, agendaList.length]);

    const agenda = agendaList.find(item => item.id === parseInt(id));

    if (loading) {
        return (
            <div className="flex justify-center items-center min-h-screen">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0D9488] mx-auto"></div>
                    <p className="mt-4 text-gray-600">Memuat agenda...</p>
                </div>
            </div>
        );
    }

    if (!agenda) {
        return (
            <div className="container mx-auto px-4 py-16 text-center">
                <h2 className="text-2xl font-bold text-gray-700">Agenda tidak ditemukan</h2>
                <Link to="/agenda" className="text-[#0D9488] hover:underline mt-4 inline-block">
                    Kembali ke daftar agenda
                </Link>
            </div>
        );
    }

    return (
        <div className="bg-gray-50 min-h-screen py-12">
            <div className="container mx-auto px-4 max-w-4xl">
                {/* Tombol Kembali */}
                <button
                    onClick={() => navigate(-1)}
                    className="flex items-center gap-2 text-[#0D9488] hover:text-[#0F766E] mb-6 transition-colors"
                >
                    <FaArrowLeft /> Kembali
                </button>

                {/* Card Detail */}
                <article className="bg-white rounded-xl shadow-lg overflow-hidden">
                    {/* Gambar */}
                    <img
                        src={agenda.image}
                        alt={agenda.title}
                        className="w-full h-80 object-cover"
                    />

                    <div className="p-6 md:p-8">
                        {/* Meta informasi */}
                        <div className="flex flex-wrap items-center gap-4 mb-4 text-sm text-gray-600">
                            <span className="flex items-center gap-1">
                                <FaCalendarAlt className="text-[#1E3A8A]" />
                                {agenda.date}
                            </span>
                            {agenda.time && (
                                <span className="flex items-center gap-1">
                                    <FaClock className="text-[#1E3A8A]" />
                                    {agenda.time}
                                </span>
                            )}
                            {agenda.location && (
                                <span className="flex items-center gap-1">
                                    <FaMapMarkerAlt className="text-[#1E3A8A]" />
                                    {agenda.location}
                                </span>
                            )}
                            <span className="flex items-center gap-1">
                                <FaTag className="text-[#1E3A8A]" />
                                <span className="bg-[#1E3A8A] text-white px-3 py-1 rounded-full text-xs">
                                    {agenda.category}
                                </span>
                            </span>
                        </div>

                        {/* Judul */}
                        <h1 className="text-3xl md:text-4xl font-bold text-[#1E3A8A] mb-4">
                            {agenda.title}
                        </h1>

                        {/* Deskripsi / Konten */}
                        <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed">
                            {agenda.content ? (
                                <div dangerouslySetInnerHTML={{ __html: agenda.content }} />
                            ) : (
                                <p>{agenda.summary}</p>
                            )}
                        </div>

                        {/* Informasi tambahan jika ada */}
                        {agenda.pic && (
                            <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
                                <h4 className="font-semibold text-[#1E3A8A] flex items-center gap-2">
                                    <FaUser className="text-[#1E3A8A]" />
                                    Penanggung Jawab
                                </h4>
                                <p className="text-gray-700 mt-1">{agenda.pic}</p>
                            </div>
                        )}

                        {/* Jika ada dokumen terkait */}
                        {agenda.documents && agenda.documents.length > 0 && (
                            <div className="mt-8">
                                <h3 className="text-xl font-semibold text-[#1E3A8A] mb-4 flex items-center gap-2">
                                    <FaFileAlt />
                                    Dokumen Terkait
                                </h3>
                                <ul className="space-y-2">
                                    {agenda.documents.map((doc, idx) => (
                                        <li key={idx}>
                                            <a
                                                href={doc.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-[#0D9488] hover:underline flex items-center gap-2"
                                            >
                                                <FaFileAlt className="text-sm" />
                                                {doc.name}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                </article>
            </div>
        </div>
    );
};

export default AgendaDetail;